import { Classification } from '@interfaces/Classification';
import { ClassificationEstimate } from '@interfaces/ClassificationEstimate';

export class ClassificationRow {
  public code: string;
  private _description: string;
  public get description(): string {
    if (this.currentLang === 'en') {
      this._description = this.classification?.description2 || this.classification?.description;
    } else if (this.currentLang === 'fr') {
      this._description = this.classification?.description;
    }

    return this._description;
  }

  public constructor(
    public currentLang: string,
    public classification: Classification,
    public classificationEstimate?: ClassificationEstimate
  ) {
    this.code = classification.code;
  }
}
